import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {AuthService}  from './Services/AuthGard.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router,private cookieService: CookieService,){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      // alert('abc');
      return this.authService.isUserLoggedIn
      .take(1)
      .map( (isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          let loginUrl =  this.cookieService.get('loginUrl');
          if(loginUrl){
            window.location.href = window.location.origin + "/login?token=" + loginUrl;
            return false;
          }
          else{
            this.router.navigate(['login']);
            return false;
          }
        }else {

          console.log(this.authService.isTokenExpired());

          if(!this.authService.isTokenExpired()){
            let role = localStorage.getItem('userRole');
            if(role == "Alignor Admin"){
              if(next.data['onlyGuests'] == "Admins" || next.data['onlyGuests'] == 'Alignor'|| next.data['onlyGuests'] == 'All' || next.data['onlyGuests'] == "Game Author"){
                return true;
              }else {
                this.router.navigate(['dashboard/portalDashboard']);
                return false;
              }
            }else if(role == "Community Admin"){
              if(next.data['onlyGuests'] == "Admins" || next.data['onlyGuests'] == 'All'){
                return true;
              }else {
                this.router.navigate(['dashboard/communityDashboard']);
                return false;
              }
            }else if(role == "Learner" || role == "Manager"){
              // alert(next.data['onlyGuests']);
              if(next.data['onlyGuests'] == "Learner" || next.data['onlyGuests'] == "Manager" || next.data['onlyGuests'] == 'All'){
                return true;
              }else {
                // alert(next.data['onlyGuests']);
                this.router.navigate(['dashboard']);
                return false;
              }
            } else if(role == 'Translator'){
              if(next.data['onlyGuests'] == "Translator" || next.data['onlyGuests'] == 'All'){
                return true;
              }else {
                this.router.navigate(['dashboard']);
                return false;
              }
            } else if(role == 'Game Author'){
              if(next.data['onlyGuests'] == "Game Author" || next.data['onlyGuests'] == 'All'){
                return true;
              }else {
                this.router.navigate(['dashboard']);
                return false;
              }
            }
          } else {
            this.authService.logout().subscribe( log =>{
              if(log.success){
                localStorage.clear();
              }
            });
            return false;
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.guard.ts